import { AuthTypography } from './EquipmentOptionStyled';
import PropTypes from 'prop-types';
import Section from './Section';
import HighlightText from 'components/UI/Inputs/AIQAutocomplete/HighlightText';

const AuthSection = ({ personnelNames, gateNames, searchTerm }) => (
    <Section label="AUTH">
        {personnelNames.length > 0 && (
            <AuthTypography>
                <strong>People:&nbsp;</strong>
                <HighlightText text={personnelNames.join(', ')} searchTerm={searchTerm} />
            </AuthTypography>
        )}
        {gateNames.length > 0 && (
            <AuthTypography>
                <strong>Access Point:&nbsp;</strong>
                <HighlightText text={gateNames.join(', ')} searchTerm={searchTerm} />
            </AuthTypography>
        )}
    </Section>
);

AuthSection.propTypes = {
    personnelNames: PropTypes.arrayOf(PropTypes.string),
    gateNames: PropTypes.arrayOf(PropTypes.string),
    searchTerm: PropTypes.string,
};

export default AuthSection;
